import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
//
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import AddIcon from "@mui/icons-material/Add";
//
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import IconPopup from "../../../../../../common/components/popup/IconPopup";
import useDebounce from "../../../../../../common/hooks/useDebounce";
import { StoreContext } from "../../../../../../store/StoreProvider";
import useModuleLimit from "../../../../../hooks/useModuleLimit";
// config, utils
import urls from "../../../../../../api/project/ApiUrls";
import { MODULE_ID, MODULE_LIMIT_ID } from "../../../../../../config/CONSTANTS";
import PopupCreate from "../../common/PopupCreate";
import fireDb from "../../../../../../api/firebase/realtime/utils";
import role from "../../../../../../config/App-role";
import Act from "../../../../../../store/actions";

const popupMenuPosition = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
};

const AccordionSummaryTail = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale, groups } = user;
  // local state
  const [listItems, setListItems] = useState([]);
  const [listItemFocus, setListItemFocus] = useState(null);
  const [popupPageIdx, setPopupPageIdx] = useState(0);
  const [popPageCtx, setPopPageCtx] = useState({});
  const [popCreateInput, setPopCreateInput] = useState("");
  const popCreateInputDebx = useDebounce(popCreateInput, 100);

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();
  const { handleLimit } = useModuleLimit();

  const userAsAdminCount = Object.values(groups).filter(
    (valObj) => valObj.role === role.admin
  ).length;
  // 自己建立的團隊總數不可以超過限制
  const disabledIconBtn =
    !handlePublic(MODULE_ID.snaSidebarGroupsAddgroup) ||
    userAsAdminCount >=
      handleLimit(MODULE_LIMIT_ID.CREATE_GROUPS_COUNT_MAX_LIMIT);

  const handleCreateInputChange = (e) => {
    setPopCreateInput(e.target.value);
  };

  const addGroupToUser =
    (groupKey) =>
    ({ uid: _uid }) => {
      // 儲存 user data
      if (_uid) {
        const newGroupData = {
          uid: groupKey,
          isMember: true,
          role: role.admin,
          // 區分正式站/測試站
          appWebMode: process.env.REACT_APP_WEB_MODE,
        };
        fireDb.updateUserGroups({
          userId: _uid,
          groupId: groupKey,
          data: {
            ...newGroupData,
          },
          onSuccess: () => {
            // 儲存 groups 至 store
            dispatch({
              type: Act.USER_SET_GROUPS,
              payload: {
                ...groups,
                [groupKey]: newGroupData,
              },
            });
            // success message
            dispatch({
              type: Act.COMMON_SET_SUCCESS_MESSAGE,
              payload: {
                open: true,
                content: intl.formatMessage({
                  id: "sna.sidebar.grouptool.create.group.success",
                  defaultMessage: "成功建立團隊",
                }),
              },
            });
          },
          onError: (error) => {
            // error message
            dispatch({
              type: Act.COMMON_SET_ERROR_MESSAGE,
              payload: {
                open: true,
                content: error.message,
              },
            });
          },
        });
      }
    };

  const handleCreatSubmit = () => {
    if (!popCreateInput) return;
    // 儲存至 firebase
    fireDb.createGroup({
      data: {
        displayName: popCreateInput,
        members: {
          [user.uid]: {
            isMember: true,
            role: role.admin,
          },
        },
      },
      onSuccess: (groupKey) => {
        // 更新 users.[uid].groups.[groupId]
        addGroupToUser(groupKey)({
          uid: user.uid,
        });
      },
      onError: (err) => {
        dispatch({
          type: Act.COMMON_SET_ERROR_MESSAGE,
          payload: {
            open: true,
            content: err.message,
          },
        });
      },
    });
  };

  const isGroupNameDuplicate =
    Object.values(groups || {}).filter((g) => g.displayName === popCreateInput)
      .length > 0;
  // 團隊名稱不可重複
  const disabledCreateSubmitBtn = !popCreateInput || isGroupNameDuplicate;

  // popup menu 允許多頁
  const popupPages = [
    {
      // body: popup 主體
      body: (
        <PopupCreate
          context={listItemFocus}
          title={intl.formatMessage({
            id: "sna.sidebar.grouptool.create.group",
            defaultMessage: "建立團隊",
          })}
          inputLabel={intl.formatMessage({
            id: "sna.sidebar.grouptool.groupname.input.label",
            defaultMessage: "團隊名稱",
          })}
          onInputChange={handleCreateInputChange}
          onSubmit={() => handleCreatSubmit()}
          submitText={intl.formatMessage({
            id: "sna.sidebar.grouptool.create.group.create",
            defaultMessage: "建立",
          })}
          disabledBtn={disabledCreateSubmitBtn}
        />
      ),
      // footer
      footer: null,
    },
  ];

  useEffect(() => {
    setPopPageCtx(popupPages[popupPageIdx]);
  }, [popupPageIdx, popCreateInput]);

  const getIconButtonProps = () => ({
    onButtonIconClick: () => null,
    sx: {
      color: "#fff",
      "&.Mui-disabled": {
        color: "#909090",
      },
    },
    disabled: disabledIconBtn,
  });

  const getMenuProps = () => ({
    sx: {
      minWidth: "272px",
    },
    ...popPageCtx,
    ...popupMenuPosition,
  });

  return (
    <IconPopup
      icon={<AddIcon />}
      iconButtonProps={getIconButtonProps()}
      menuProps={getMenuProps()}
    />
  );
};

export default AccordionSummaryTail;
